/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../common/Loading';
import NewConnection from './NewConnection';
import NewGig from './NewGig';
import NewRating from './NewRating';
import NewResource from './NewResource';
import NewComment from './NewComment.js';
import NewConnectionResourceRating from './NewConnectionResourceRating.js';
import ArtistService from '../../services/artistService';
import * as artistAdminActions from '../../actions/artistAdminActions';
import * as accountActions from '../../actions/accountActions';
import NewForumPost from './NewForumPost';
import Advert from '../common/Advert.js';
import ErrorMessage from '../common/ErrorMessage.js';
import * as imageUtils from '../../utils/imageUtils';

class NewsFeedPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.loadNotifications = this.loadNotifications.bind(this);
        this.state = {
            notifications: [],
            page: 0,
            totalPages: 0,
            loading: false,
            loadingError: false,
            loadingPage: 0
        };
    }

    componentWillMount() {
        this.loadNotifications();
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        const activeProfileSet = this.props.activeProfile && !prevProps.activeProfile;
        const activeProfileUpdated = this.props.activeProfile && prevProps.activeProfile && this.props.activeProfile.ID !== prevProps.activeProfile.ID;
        if(activeProfileSet || activeProfileUpdated) {
            this.loadNotifications();
        }
    }

    loadNotifications(page = 1) {
        if(this.props.activeProfile && this.props.activeProfile.ID) {
            this.setState({ loading: true, loadingPage: page, loadingError: false });
            this.props.actions.getNotifications(this.props.activeProfile.ID, page)
                .then(notifications => {
                    //if we're on page 1, replace the current result, else add to it
                    const currentNotifications = page == 1 ? notifications.Items : [...this.state.notifications].concat(notifications.Items);
                    this.setState({
                        notifications: currentNotifications, 
                        page: notifications.Page, 
                        totalPages: notifications.TotalPages,
                        loading: false,
                        loadingError: false
                    }, () => {
                        //now we've read it, reload the notifications count
                        this.props.actions.refreshNotificationCount(this.props.activeProfile.ID);
                    });
                })
                .catch(error => {
                    this.setState({ loading: false, loadingError: true });
                });
        }
    }
    
    getNotification(item, index) {
        if(item.ActivityType === 'NewResourceRating') {
            return <NewRating item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewConnection') {
            return <NewConnection item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewResource') {
            return <NewResource item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewComment') {
            return <NewComment item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewGig') {
            return <NewGig item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewConnectionResourceRating') {
            return <NewConnectionResourceRating item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewForumPost') {
            return <NewForumPost item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
    }

    getThumbnail(imageUrl, roleType) {
        const params = '?width=120&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    render() {
        return (
            <div className="main">
                <MetaTags>       
                    <title>Notifications - LoudUp</title>     
                    <meta id="description" name="description" content="Get updated on what is currently happening across the site from new users to new music, new discussion and more!" />   
                </MetaTags>
                <div className="container">
                    <div className="block-inner minimal-height">
                        {
                            this.props.activeProfile ? 
                                <React.Fragment>
                                    <h1 className="section-alt">Notifications for {`${this.props.activeProfile.DisplayName} (${ArtistService.getRoleTypeFriendlyName(this.props.activeProfile.RoleType)})`}</h1>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div id="newsFeedContainer">
                                            {
                                                this.state.notifications && this.state.notifications.length ?
                                                    <ul id="ulNewsFeedData" className="list-unstyled itemlist feed">
                                                    {
                                                        this.state.notifications.map((item, index) =>  {
                                                            return <React.Fragment key={index}>
                                                                {this.getNotification(item, index)}
                                                                {
                                                                    index === 3 || (index > 0 && index % 23 === 0) ?
                                                                        <li className="sponsored">
                                                                            <p className="type">SPONSORED POST</p>
                                                                            <div className="message">
                                                                                <p>
                                                                                    <Advert adType="Footer" textOnly />
                                                                                </p>
                                                                            </div>
                                                                        </li>
                                                                        : null
                                                                }
                                                            </React.Fragment>;                           
                                                        })
                                                    }
                                                    </ul>
                                                    : 
                                                    this.state.loading ? 
                                                        <Loading />  
                                                        : 
                                                        this.state.loadingError ?
                                                            <ErrorMessage error="Sorry, something went wrong! Unable to load notifications" />
                                                            : 
                                                            <p>There are no notifications to display</p>
                                                    
                                            }
                                            {
                                                this.state.totalPages > this.state.page ?
                                                    this.state.loading && this.state.loadingPage > 1 ?
                                                        <Loading /> :
                                                        <React.Fragment>
                                                            <div id="divLoadNext" style={{textAlign:'center'}}>
                                                                <button id="btnLoadNext" className="btn btn-outline transition" style={{marginTop:'15px'}} onClick={() => this.loadNotifications(this.state.page + 1)}>Show More...</button>
                                                            </div>
                                                            {
                                                                this.state.loadingError ?
                                                                    <p style={{ textAlign: 'center', paddingTop: '20px' }}>Sorry, something went wrong! Unable to load more notifications</p>
                                                                    : null
                                                            }
                                                        </React.Fragment>
                                                    : null
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            : <div />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

NewsFeedPage.propTypes = {
    activeProfile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { activeProfile: state.account.user.activeProfile };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, artistAdminActions, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsFeedPage);